import { action, computed, makeObservable, observable, reaction } from 'mobx';
import { AutocompleteViewModel } from 'shared/components/autocomplete';
import { countries } from 'Components/employersSide/Jobseekers/settings';
import { City, Locality } from 'candidate/types';

export class PersonalInfoStore {
   valid = false;

   name: string = '';
   lastName: string = '';
   middleName: string = '';
   birthDate: string = '';
   gender: string = '';
   country: string = '';

   private readonly countries = countries;
   readonly countryVM = new AutocompleteViewModel<Locality>(null, {
      getLabel: (item) => {
         return item.name;
      },
   });

   readonly cityVM = new AutocompleteViewModel<City>(null,{
      getLabel:(item) => {
      return item.label;
   } 
   } );

   constructor() {
      makeObservable(this, {
         name: observable,
         lastName: observable,
         middleName: observable,
         birthDate: observable,
         gender: observable,
         country: observable,

         onNameChange: action.bound,
         onLastNameChange: action.bound,
         onMiddleNameChange: action.bound,
         onBirthDateChange: action.bound,
         onGenderChange: action.bound,
         cityVM: observable,
         filterdCountries: computed,
      });

      reaction(
         () => this.countryVM.value,
         (e) => {
            console.log(e, 'VALUE');
         }
      );
   }

   get filterdCountries() {
      return this.countries.filter((country) =>
         country.name.toLowerCase().includes(this.countryVM.search.toLowerCase())
      );
   }

   onNameChange(value: string): void {
      this.name = value;
   }

   onLastNameChange(value: string): void {
      this.lastName = value;
   }

   onMiddleNameChange(value: string): void {
      this.middleName = value;
   }

   onBirthDateChange(value: string): void {
      this.birthDate = value;
   }

   onGenderChange(value: string): void {
      this.gender = value;
   }
}
// valueKey={() => {
// 									const country = countries.find(
// 										(c) => String(c.id) === personalInfoCtx.value.country
// 									);

// 									return country?.name ?? '';
// 								}}
// 								filter={(countryId, s) => {
// 									const country = countries.find(
// 										(c) => c.id === Number(countryId)
// 									);
// 									const match = country?.name
// 										.toLowerCase()
// 										.includes(s.toLowerCase());
// 									return match ? 1 : 0;
// 								}}
// 								onSelect={(countryId) => {
// 									const country = countries.find(
// 										(c) => c.id === Number(countryId)
// 									);
// 									if (country) {
// 										personalInfoCtx.set('country', countryId);
// 									} else {
// 										personalInfoCtx.set('country', '');
// 									}

// 									personalInfoCtx.set('city', null);
// 									setCities([]);
// 								}}
